import React from "react";
import {DashboardOutlined} from "@mui/icons-material";

import DashboardTable from "../../../../components/Reporting/DashboardTable";
import Applet from "../../Applet";

// The list of dashboards.
//
// COLUMNS ARE FIXED HERE, unlike the report result beside it: a dashboard has the same three facts
// every time -- what it is called, what it says it is for, and how many tiles are on it -- so they
// are declared in state rather than rebuilt per render. The result grid does the opposite because
// its columns are a function of the last run; neither is the general rule.
//
// TILES IS NARROW, AND LEFT-RANGED LIKE EVERYTHING ELSE. Right-ranging a count would read better,
// and PlatformTable cannot do it: columns take `headerAlign`, the CELL renderers take no alignment
// at all, and an `align` property here is silently ignored. Left it out rather than left it in
// looking configured -- making it work means changing renderStandardSingleCell, which every list in
// the suite shares, for one column on one screen.
class DashboardTableApplet extends Applet {

    render() {
        return <DashboardTable applet={this}
                               pageSize={this.state.PageSize}
                               placement={this.state.Placement}
                               columns={this.state.Columns}
                               title="Dashboards"
                               icon={<DashboardOutlined sx={{color: "#1498D8"}}/>}
                               enterpriseComponent={this.getEnterpriseComponent()}
                               sort={this.state.Sort}
                               rowHeight={this.state.RowHeight}
                               simpleSearch={this.state.SimpleSearch}
                               readOnly={true}
        />;
    }

    state = {
        Name: "DashboardTableApplet",
        RowHeight: 48,
        PageSize: {"default": 25, "xs": 5, "sm": 5},
        SimpleSearch: {Attributes: ["Name", "Description"]},
        Placement: {
            "xl": [{id: "Name"}, {id: "Description"}, {id: "Tiles"}],
            "lg": [{id: "Name"}, {id: "Description"}, {id: "Tiles"}],
            "md": [{id: "Name"}, {id: "Description"}, {id: "Tiles"}],
            // NARROW SCREENS DROP THE DESCRIPTION, not the count: the count is what tells somebody
            // whether a dashboard has anything on it, and a description is the first thing that can
            // be read on the page it links to.
            "sm": [{id: "Name"}, {id: "Tiles"}],
            "xs": [{id: "Name"}, {id: "Tiles"}],
        },
        Columns: [
            {
                id: "Name",
                width: 320,
                cellRenderer: "Link Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "Description",
                width: 520,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Description",
            },
            {
                id: "Tiles",
                width: 90,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Tiles",
            },
        ],
    };
}

export default DashboardTableApplet;
